define('SageDotCom/Components/PartnerSearchFilters',["jquery",
    "underscore",
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/findPartnerSearch',
    "eventManager",
    "text!SageDotCom/Components/Templates/PartnerSearchFilter.html"],
    function ($, _, tealium, findPartnerSearch, eventManager, partnerSearchFilterTemplate) {
        function PartnerSearchFilters(scope, partnerFilterName, partnerFilterButtonName, partnerFilterMatchingResultsLabel) {
            var modelTemplateData = {
                areFiltersVisible : false,
                availableFilters: []
            }

            var $partnerSearchFiltersTemplateDiv = $(".js-partner-search-filters-template", scope);
            var currTemplate = partnerSearchFilterTemplate.replace("#PartnerFilterName#", partnerFilterName);
            currTemplate = currTemplate.replace("#PartnerFilterButtonName#", partnerFilterButtonName);
            var _partnerSearchFilterTemplate = _.template(currTemplate);

            function specialisms(partners) {
                var specialisms = _.map(partners, function (partner) {
                    return _.filter(partner.variants || [], { type: 'specialism' });
                });

                specialisms = _.flatten(specialisms);

                specialisms = _.uniq(specialisms, function (specialism) {
                    return specialism.variantName;
                });

                specialisms = _.reject(specialisms, function(specialism) {
                    return specialism.variantName === "";
                });

                specialisms = _.sortBy(specialisms, function(specialism) {
                    return specialism.variantName;
                });

                return specialisms;
            };

            eventManager.subscribe("partner-search-filter-triggered", function (partners) {
                if (partners.length === 0) {
                    $partnerSearchFiltersTemplateDiv.html("");
                } else {
                    modelTemplateData.availableFilters = specialisms(partners);
                    var html = "";
                    html += _partnerSearchFilterTemplate(modelTemplateData);
                    $partnerSearchFiltersTemplateDiv.html(html);
                }

                scrollToTheSearchResultTitle();
            });

            $(document).on("click", "#partner-search-refine", function (event) {
                scrollToTheSearchResultTitle();

                $(".filters").toggleClass("open");

                var selectedFilters = [];
                $('.filter-checkbox').each(function () {
                    var checkBoxValue = (this.checked ? $(this).val() : "");
                    if (checkBoxValue != "") {
                        selectedFilters.push(_.filter(modelTemplateData.availableFilters || [], { variantName: checkBoxValue })[0]);
                    }
                });

                eventManager.trigger("partner-search-apply-filter-triggered", selectedFilters, partnerFilterMatchingResultsLabel);
                var extendedData = {
                    "partner": $("#partner-search-partner-type option:selected").text(),
                };
                var eventSchema = findPartnerSearch.GenerateEventMetadata(scope, extendedData);
                tealium.event(eventSchema);
            });

            $(document).on("click", ".filter-toggle", function (event) {
                event.preventDefault();
                $(".filters").toggleClass("open");
            });

            function scrollToTheSearchResultTitle() {
                var stickyNavHeight = calculateStickyNavHeight();

                $('html, body').animate({
                    scrollTop: ($('.js-partner-search-stats').offset().top - stickyNavHeight)
                }, 500);
            }

            function calculateStickyNavHeight() {
                var stickyNav = $(".sticky-nav.stick");
                var stickyNavHeight = 0;

                if (stickyNav.length > 0 && (stickyNav.css("top") === "0" || stickyNav.css("top") === "0px") && (stickyNav.css("position") === "sticky") || (stickyNav.css("position") === "fixed")) {
                    stickyNavHeight = $(".sticky-nav.stick").height();
                }
                return stickyNavHeight;
            }
        }

        return function initPartnerSearch(args) {
            return args.IsExperienceEditorEditing === false ?
                new PartnerSearchFilters(args.scope,
                    args.PartnerFilterName,
                    args.PartnerFilterButtonName,
                    args.PartnerFilterMatchingResultsLabel) : null;
        };
    });
